// API Configuration
export const API_BASE_URL = "http://13.210.85.72:80";

// API Endpoints
export const API_ENDPOINTS = {
  NEW_CONVERSATION: `https://us-central1-twitaar-ex.cloudfunctions.net/kallistoChatConv`,
  CHAT: `https://us-central1-twitaar-ex.cloudfunctions.net/kallistoChat`
};
